import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, Grid, Typography, Avatar } from '@material-ui/core';
// add
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import CardActionArea from '@material-ui/core/CardActionArea';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  },
  difference: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  differenceIcon: {
    color: theme.palette.success.dark
  },
  differenceValue: {
    color: theme.palette.success.dark,
    marginRight: theme.spacing(1)
  },
  labelAction: {
    width: '100%',
    textAlign: 'center'
  }
}));

const profiles = {
  admin: "Administrateur",
  regisseur: "Régisseur", 
  placier: "Placier"
}

const TotalUsers = props => {
  const { className, elevation, data, ...rest } = props;

  const classes = useStyles();

  return (

    <CardActionArea component={RouterLink} to="/settings/users/add">
      <Card
        {...rest}
        elevation={elevation}
        className={clsx(classes.root, className)}
      >
        <CardContent>
          <Grid
            container
            justify="space-between"
          >
            <Grid item>
              <Typography
                className={classes.title}
                color="textSecondary"
                gutterBottom
                variant="body1"
              >
                Utilisateurs enregistrés
            </Typography>
              <Typography variant="h3" gutterBottom>{data.nombre}</Typography>
            </Grid>
            <Grid item>
              <Avatar className={classes.avatar}>
                <GroupAddIcon className={classes.icon} />
              </Avatar>
            </Grid>
          </Grid>
          <div className={classes.difference}>
            <Typography
              gutterBottom
              className={classes.caption}
              variant="body2"
            >
              {'Dernier utilisateur créé "' + data.last.username + '" en tant que ' + profiles[data.last.role]}
            </Typography>
          </div>
          <div className={classes.difference}>
            <Typography
              className={classes.labelAction}
              variant="subtitle2"
              color="primary"
            >
             Créer un utilisateur
            </Typography>
          </div>
        </CardContent>
      </Card>
    </CardActionArea>
  );
};

export default TotalUsers;
